import DaisyBaseService from './../../../services/DaisyBaseService';

/**
 * this is the transport order service to handle the communication with the daisy backend
 **/
export default class TransferOrderService extends DaisyBaseService {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.$timeout = $injector.get('$timeout');
		this.baseUrl += 'Transportauftraege';
        this.moment = $injector.get('moment');
		this.$session = $injector.get('$sessionStorage');
		this.$storage = $injector.get('$localStorage');
	}

	/**
	 * create empty transfer order object
	 * @return {object} transfer order
	 */
	createTransferOrderObject() {
		return {
			"USER_ID": this.$session.auth.USER_ID,
			"wunschtermin": new Date(),
			"start": {
				"typ": "stUnbekannt",
				"id": 0
			},
			"ziel": {
				"typ": "stUnbekannt",
				"id": 0
			},
			"positionen": [
				{
					"posNr": 1,
					"transportgutText": "",
				}
			],
			"filterResult": {
				"USER_ID": 0,
				"vonDatum": "",
				"bisDatum": "",
				"transportauftragsId": 0
			}
		};
	}

	/**
	 * create transfer order object to create a new transfer order
	 * @param {object}  order
	 * @return {object} request order
	 */
	createTransferOrderCreateObject(order) {
		return {
			"USER_ID": this.$session.auth.USER_ID,
			"wunschtermin": order.wunschtermin,
			"start": {
				"typ": order.start.typ,
				"id": order.start.id
			},
			"ziel": {
				"typ": order.ziel.typ,
				"id": order.ziel.id
			},
			"positionen": order.positionen,
			"filterResult": {
				"USER_ID": 0,
				"vonDatum": "",
				"bisDatum": "",
				"transportauftragsId": 0
			}
		};
	}

	/**
	 * create transfer order object to delete a transfer order
	 * @param {object} request order
	 * @return {object} request order
	 */
	createTransferOrderDeleteObject(order) {
		return {
			"USER_ID": this.$session.auth.USER_ID,
			"transportauftragId": order.id,
			"geloescht": order.geloescht,
			"filterResult": {
				"USER_ID": 0,
				"vonDatum": "",
				"bisDatum": "",
				"transportauftragsId": 0
			}
		};
	}

	/**
	 * create request object
	 * @param  {object} order 
	 * @return {object} request order
	 */
	createTransferOrderEditObject(order) {
		return {
			"USER_ID": this.$session.auth.USER_ID,
			"transportauftragId": order.id,
			"wunschtermin": order.wunschtermin,
			"start": {
				"typ": order.start.typ,
				"id": order.start.id
			},
			"ziel": {
				"typ": order.ziel.typ,
				"id": order.ziel.id
			},
			"verantwortlichePersionId": order.verantwortlichePerson.id,
			"statusId": order.status.id,
			"kommentar": order.kommentar,
			"positionen": [],
			"filterResult": {
				"USER_ID": 0,
				"vonDatum": "",
				"bisDatum": "",
				"transportauftragsId": 0
			}
		};
	}

	createTransferOrderBookObject(order){
		return {
            "USER_ID": this.$session.auth.USER_ID,
            "transportauftragId": order.id,
            "positionen": [],
            "filterResult": {
                "USER_ID": 0,
                "vonDatum": "",
                "bisDatum": "",
                "transportauftragsId": 0
            }
		}
	}

    createArtikelUmbuchenObject(
    	artikel,
		menge,
		quellLagerOrt,
		charge,
		zielLagerOrt
	)
	{
		let quelle = {
            "chargeSNrId": 0,
            "quellLagerortId": 0,
            "menge": parseFloat(menge)
		};
        if (quellLagerOrt !== null){
            quelle["quellLagerortId"] = quellLagerOrt.lgrortId
        }
        if (charge !== null){
            quelle["chargeSNrId"] = charge.chargeSNrId
        }

        return {
            "USER_ID": this.$session.auth.USER_ID,
            "artikelId": artikel.artikelId,
            "quellLagerorte": [
                quelle
			],
            "zielLagerortId": parseInt(zielLagerOrt.id),
            "zielStandortTyp": zielLagerOrt.typ
        };
	}
	
	/**
	 * delete transfer order
	 * @param {Object} order
	 **/
	deleteTransferOrder(order) {
		let functionUrl = '/TransportauftragLoeschen';
		let data = {
			request: order
		};
		
		return this.doPost(functionUrl, data);
	}

	/**
	 * edit transfer order
	 * @param {Object} order - Object with the current transfer order to store
	 **/
	editTransferOrder(order) {
		let functionUrl = '/TransportauftragAEndern';
		let data = {
			request: order
		};
		
		return this.doPost(functionUrl, data);
	}

    subtractWorkDays(startDate, amountOfWorkDays){
        let momentDate = this.moment(startDate);

        while (amountOfWorkDays > 0){
            momentDate.subtract(1, 'days');
        	if (momentDate.day() !== 0 && momentDate.day() !== 6){
        		amountOfWorkDays = amountOfWorkDays - 1;
			}
        }
        return momentDate.toDate();
	}

	/**
	 * get all transfer orders
	 **/
	getTransferOrders() {
		let functionUrl = '/ladeTransportauftraege';

        let today = new Date();
        today.setHours(0,0,0);

		// ToDo: Setze Start- und Enddatum
		let startDate = this.subtractWorkDays(today, 5);
        const startISO = startDate.toISOString();

		let data = {
			"request": {
				"USER_ID": ("auth" in this.$session)?parseInt(this.$session.auth.USER_ID):0,
				"vonDatum": startISO
			}
		};

		return this.doPost(functionUrl, data);
	}

	/**
	 * get transfer order
	 **/
	getTransferOrder(id) {
		let functionUrl = '/ladeTransportauftrag';
		let data = {id: id};

		return this.doPost(functionUrl, data);
	}

	/**
	 * get transfer order states
	 * @param {boolean} whether or not return state from localStorage
	 * @return {promise}
	 **/
	ladeStatusAuswahl(cache = false) {
		if(cache) {
			return new Promise((resolve, reject) => {
				resolve(this.$storage.orderState);
			});
		}

		let functionUrl = '/ladeStatusAuswahl';
		let data = {};

		return this.doPost(functionUrl, data)
			.then(response => {
				this.$storage.orderState = response;
				return response;
			});
	}


	/**
	 * save transfer order
	 * @param {Object} order - Object with the current transfer order to store
	 **/
	saveTransferOrder(order) {
		let functionUrl = '/TransportauftragErstellen';
		let data = {
			request: order
		};
		
		return this.doPost(functionUrl, data);
	}

    bookTransferOrder(order){
		let functionUrl =  '/transportauftragAendernUndBuchen';

        let data = {
            request: order
        };

        return this.doPost(functionUrl, data);
	}

    ladeArtikelInfo(artikelNr){
		let functionUrl =  '/ladeArtikelInfo';

        let data = {
            request: {
                "artikelNr": artikelNr,
                "artikelId": 0
			}
        };

        return this.doPost(functionUrl, data);
	}

    artikelUmbuchen(artikelUmbuchenRequest){
        let functionUrl =  '/artikelUmbuchen';

        let data = {
            request: artikelUmbuchenRequest
        };

        return this.doPost(functionUrl, data);
	}
}
